import { render, staticRenderFns } from "./BalanceWithdrawRecharge.vue?vue&type=template&id=4dae348a&scoped=true"
import script from "./BalanceWithdrawRecharge.vue?vue&type=script&lang=js"
export * from "./BalanceWithdrawRecharge.vue?vue&type=script&lang=js"
import style0 from "./BalanceWithdrawRecharge.vue?vue&type=style&index=0&id=4dae348a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dae348a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dae348a')) {
      api.createRecord('4dae348a', component.options)
    } else {
      api.reload('4dae348a', component.options)
    }
    module.hot.accept("./BalanceWithdrawRecharge.vue?vue&type=template&id=4dae348a&scoped=true", function () {
      api.rerender('4dae348a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/financials-agent/components/Balance/BalanceWithdrawRecharge.vue"
export default component.exports